import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const SaleAlertToggle = () => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/votel/sale-alerts").then((r) => setS(r.data));
  }, []);
  const toggle = async (v) => {
    try { const r = await api.put("/admin/votel/sale-alerts", { enabled: v }); setS(r.data); toast.success(v ? "Sale alerts on" : "Sale alerts off"); }
    catch (e) { toast.error(apiError(e.response?.data?.detail)); }
  };
  if (!s) return null;
  return (
    <div className="flex items-center justify-between rounded-sm border border-border bg-card p-5" data-testid="sale-alert-card">
      <div>
        <h3 className="font-heading font-semibold">New sale alert (Telegram)</h3>
        <p className="text-xs text-muted-foreground">
          Notifies Todd through the existing alert route when a Votel sale is credited to a rep.
          {!s.route_configured && " Alert route URL not configured yet."}
        </p>
      </div>
      <Switch checked={s.enabled} disabled={!s.route_configured && !s.enabled} onCheckedChange={toggle} data-testid="sale-alert-toggle" />
    </div>
  );
};
